import { render } from "./SupplierReport.vue?vue&type=template&id=250840c4&scoped=true&ts=true"
import script from "./SupplierReport.vue?vue&type=script&lang=ts"
export * from "./SupplierReport.vue?vue&type=script&lang=ts"

import "./SupplierReport.vue?vue&type=style&index=0&id=250840c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250840c4"]])

export default __exports__